import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { store } from '../../store/store';


const baseUrl = process.env.REACT_APP_base_URL;

export const getBusinessUserRequirement  = createApi({
    reducerPath: 'getBusinessUserRequirement',
    baseQuery: fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: (headers) => {
        // const token = useSelector((state)=> state.user.token)
        const token = store.getState().user.token;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
    }),
    endpoints: (builder) => ({
      fetchBusinessUserRequirement: builder.query({
        query: ({ userId, boardId , solutionRequirementId}) => ({
          url: `requirement_boards/solution-provider/view-requirement?board_id=${boardId}&solutionRequirementId=${solutionRequirementId}`,
          method: 'GET',
        }),
        transformResponse: (response) => {
          if(response.status != "error"){
            return response.data
          }else{
           return  response = [];
          }
        },
        refetchOnWindowFocus: true,
        // retry: RetryOnError,
        onError: (error) => {
          console.error('Fetch business user requirement error:', error);
          // Handle error cases as per your application's requirements
        },
      })
    })
})


export const { useFetchBusinessUserRequirementQuery } = getBusinessUserRequirement;
export default getBusinessUserRequirement;